import React from 'react';

export default () => (
  <svg width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.596 5.69686L1.233 9.38886C0.693 9.70186 0 9.32286 0 8.69186V1.30786C0 0.67786 0.692 0.29786 1.233 0.61186L7.596 4.30386C7.71884 4.37398 7.82094 4.47535 7.89196 4.59767C7.96299 4.71999 8.00039 4.85892 8.00039 5.00036C8.00039 5.1418 7.96299 5.28073 7.89196 5.40305C7.82094 5.52537 7.71884 5.62674 7.596 5.69686V5.69686Z" fill="white" />
  </svg>
);
